import SecondaryButton from "../core/SecondaryButton";
import classes from "./pagination.module.css";

interface IProps {
  count: number;
  current: number;
  onChange: (value: number) => void;
}

const Pagination = ({ count, current, onChange }: IProps) => {

  const handleChange = (value: number) => () => {
    onChange(value);
  };

  const getItems = () => {
    const items = [];
    const limit = 2;

    if (current > 1) {
      for (let page = current - 1, i = 0; page >= 1 && i < 2; page--, i++) {
        items.unshift(<SecondaryButton key={page} onClick={handleChange(page)}>{ page }</SecondaryButton>);
      }

      items.unshift(<SecondaryButton key="previous" onClick={handleChange(current - 1)}>&lsaquo;</SecondaryButton>);
      items.unshift(<SecondaryButton key="start" onClick={handleChange(1)}>&laquo;</SecondaryButton>);
    }

    items.push(<SecondaryButton key={current} variant="active"><div>{ current }</div></SecondaryButton>);

    if (current !== count) {
      for (let page = current + 1, i = 0; page <= count && i < limit; page++, i++) {
        items.push(<SecondaryButton key={page} onClick={handleChange(page)}>{ page }</SecondaryButton>);
      }

      items.push(<SecondaryButton key="next" onClick={handleChange(current + 1)}>&rsaquo;</SecondaryButton>);
      items.push(<SecondaryButton key="end" onClick={handleChange(count)}>&raquo;</SecondaryButton>);
    }

    return items;
  };

  return (
    <div className={classes.pagination}>
      { getItems() }
    </div>
  );
};

export default Pagination;
